import {Tabs as MaterialTabs, Tab} from "@mui/material"
import {useLocation, useNavigate} from "react-router-dom"
import styled from "styled-components"

import {OffersTab} from "./CustomerOffers/OffersTab"

import type {Customer} from "@indebted/api"

type TabItem = {
	path: string
	tab: (onClick: () => void) => React.ReactElement
}

function Tabs({customer}: {customer: Customer}) {
	const location = useLocation()
	const navigate = useNavigate()

	const base = `/customers/${customer.ID}`
	const suffix = location.pathname.slice(base.length)

	function go(path: string) {
		navigate(`${base}${path}${location.search}`)
	}

	const tabs: TabItem[] = [
		{path: "", tab: (onClick) => <AlignedTab key="Overview" label="Overview" onClick={onClick} />},
		...(customer.EnableRocketCasesTab
			? [
					{
						path: "/cases",
						tab: (onClick: () => void) => <AlignedTab key="Cases" label="Cases" onClick={onClick} />,
					},
				]
			: []),
		{path: "/notes", tab: (onClick) => <AlignedTab key="Notes" label="Notes" onClick={onClick} />},
		{path: "/accounts", tab: (onClick) => <AlignedTab key="Accounts" label="Accounts" onClick={onClick} />},
		{
			path: "/transactions",
			tab: (onClick) => <AlignedTab key="Transactions" label="Transactions" onClick={onClick} />,
		},
		{
			path: "/paymentplans",
			tab: (onClick) => <AlignedTab key="Payment Plans" label="Payment Plans" onClick={onClick} />,
		},
		{path: "/activities", tab: (onClick) => <AlignedTab key="Activities" label="Activities" onClick={onClick} />},
		...(customer.EnableRocketOffersTab
			? [{path: "/offers", tab: (onClick: () => void) => <OffersTab key="Offers" onClick={onClick} />}]
			: []),
	]

	const index = Math.max(
		0,
		tabs.findIndex(({path}) => path === suffix || (path !== "" && suffix.startsWith(path + "/"))),
	)

	return (
		<MaterialTabs value={index} variant="scrollable" scrollButtons>
			{tabs.map(({path, tab}) => tab(() => go(path)))}
		</MaterialTabs>
	)
}

const AlignedTab = styled(Tab)`
	min-width: auto;
	max-width: auto;
	padding: 6px 12px;
`

export {Tabs}
